import React, { useState, useEffect } from 'react';
import '../Review.css';
import {
    Grid, Box, Chip, TextField, Typography, TextareaAutosize, MenuItem, Button, Divider, Backdrop, CircularProgress,
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Paper, Stack, Modal
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from "@mui/x-data-grid";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { SaveOutlined, DrawRounded, TaskAltOutlined, DownloadOutlined, UploadOutlined, Close, UploadFile, TaskAltRounded, AccessibilityNewOutlined, SpeakerNotesOutlined, DoNotDisturbOutlined } from '@mui/icons-material';
import { GetOrderStatus, GetScenarios, GetQuotaDetailsForScenario, GetWeekStatus, setState, reset } from '../reviewSlice';
import CollapseSection from '../../../components/ui/CollapseSection';
import Modification from './Modification';
import { green, orange, red, grey, blue } from '@mui/material/colors';
import MessageForReview from '../MessageForReview'
import './Modification.css';

// Define a function to get Chip properties based on cell value
function getChipProps(params) {
    if (params.value === 1) {
        return {
            label: "Low",
            style: {
                fontWeight: 'bold',
                //borderColor: green[500],
                backgroundColor: green[50],
                color: green[500],
            },
        };
    }

    else if (params.value === 2) {
        return {
            label: "Medium",
            style: {
                fontWeight: 'bold',
                borderColor: orange[500],
                backgroundColor: orange[50],
                color: orange[500]
            },
        };
    }

    else if (params.value === 3) {
        return {
            label: "High",
            style: {
                fontWeight: 'bold',
                borderColor: red[500],
                backgroundColor: red[50],
                color: red[500]
            },
        };
    }

    else if (params.value === 4) {
        return {
            label: "Severe",
            style: {
                fontWeight: 'bold',
                borderColor: grey[700],
                backgroundColor: grey[100],
                color: grey[700]
            },
        };
    }

    else {
        return {
            label: "Other",
            style: {
                fontWeight: 'bold',
                borderColor: blue[500],
                backgroundColor: blue[50],
                color: blue[500]
            },
        };
    }
}

let w = 135;
const columns = [
    { field: "scenarioName", headerName: "Scenario", flex: 1, minWidth: 230 },
    {
        field: "geoCode",
        headerName: "Country",
        flex: 0.5, minWidth: 100,
    },
    {
        field: "criticalityId",
        headerName: "Criticality",
        align: "center",
        headerAlign: "center",
        flex: 0.5, minWidth: 150,
        renderCell: (params) => {
            return <Chip sx={{ height: "1.8rem", minHeight : "1.8rem", padding: "0.5rem", }} {...getChipProps(params)} />;
        },
    },
    {
        field: "quota",
        headerName: "Quota",
        flex: 0.8, minWidth: 100,
        align: "center",
        headerAlign: "center",
        valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
        }
    },
    {
        field: "efs",
        headerName: "EFS",
        flex: 0.8, minWidth: 100,
        align: "center",
        headerAlign: "center",
        valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString('en-US');
            return formattedValue;
        }
    },
];


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


const ReviewOrdersandQuota = () => {
    const dispatch = useDispatch();
    const [isCollapseOpened, setIsCollapseOpened] = useState(false);
    const [isModificationOpened, setIsModificationOpened] = useState(false);
    const [open, setOpen] = useState(false)
    const review = useSelector((state) => state.review);
    const {
        isLoading,
        countries,
        selectedCountry,
        selectedCountryID,
        orderStatus,
        selectedOrderStatus,
        selectedPeriod,
        getScenarios,
        displayModification,
        searchTxt,
        isNavigate,
        isCollapseOpen,
        clearReviewTable,
        getQuotaDetails,
        RecallList
    } = review;
    const [searchText, setSearchText] = useState(searchTxt);


    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (orderStatus.length <= 0) {
            dispatch(GetOrderStatus({ method: "Get" }));
        }
    }, []);
    useEffect(() => {
        setIsCollapseOpened(isCollapseOpen);
    }, [isCollapseOpen]);
    useEffect(() => {
        if (!isNavigate) {
            dispatch(reset("refresh"));
        } else {
            dispatch(reset("navigate"));
            dispatch(setState("isNavigate", false));
        }
    }, [])

    useEffect(() => {
        setIsCollapseOpened(false);
        setIsModificationOpened(false);
        dispatch(setState("clearReviewTable", false));
    }, [clearReviewTable]);

    //Upon clicking the scenarios datagrid row
    const handleRetriveModify = () => {
        dispatch(setState("isModifyClicked", true));
          dispatch(setState("ModifiedList", getQuotaDetails));
          dispatch(
            setState("updatedWeeklyData", getQuotaDetails?.quotaCusumptionCustomers)
          );
            dispatch(
              setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers)
            );
            dispatch(setState("CustomerSearchTxt", ""));
            dispatch(setState("ProductSearchTxt", ""));
        dispatch(setState("displayModification", true));
        setIsModificationOpened(true);
      };

    const handleCountryChange = (e) => {
        const name = e.target.value;
        let countryID = 0;
        if (name !== "All") {
            countryID = countries.find(
                (country) => country.countryName === name
            ).countryID;
        }

        dispatch(setState("selectedCountry", name));
        dispatch(setState("selectedCountryID", countryID));
    }

    // const handleOrderStatusChange = (e) => {
    //     const order = e.target.value;
    //     dispatch(setState("selectedOrderStatus", order));
    // }

    const handlePeriodChange = (e) => {
        const period = e.target.value;
        dispatch(setState("selectedPeriod", period));
    }

    const handleSearchText = (e) => {
        let value = e.target.value;
	  
		// Remove special characters
		value = value.replace(/[^a-zA-Z0-9 ]/g, "");
	  
		//Replace multiple consecutive spaces with a single space
		value = value.replace(/\s{2,}/g, " ");
	  
		// Trim leading space
		value = value.trimStart();
        setSearchText(value);
        dispatch(setState("searchTxt", value));
    }
    const showMessage = (message, severity) => {
        dispatch(setState("message", message));
        dispatch(setState("severity", severity));
        dispatch(setState("messageOpen", true));
    };
    const handleRetrive = () => {
        dispatch(reset("clear"));
        setIsCollapseOpened(false);
        setIsModificationOpened(false);
        if (selectedCountryID === null || selectedCountryID === "") {
            showMessage("Please select country", "info");
            return;
        }
        // else if (selectedOrderStatus === null || selectedOrderStatus === "") {
        //     showMessage("Please select Order status", "info");
        //     return;
        // }
        else if (selectedPeriod === null || selectedPeriod === "") {
            showMessage("Please select period", "info");
            return;
        }
        const obj = {
            countryID: selectedCountryID,
            orderStatus: "All",
            searchText: searchText,
            period: selectedPeriod
        }

        const newObj = {
            scenarioId: null,
            quotaId: null
        }
        dispatch(GetScenarios(obj));
        dispatch(setState("clearQCTable", true));
        dispatch(setState("clearMTable", true));
    }
    useEffect(()=>{
        if(getQuotaDetails!==undefined && getQuotaDetails!==null){
            handleRetriveModify();
        }

    },[getQuotaDetails]);

    const handleRowClick = (rowData) => {
        dispatch(setState("displayFileButtons",false));
        dispatch(setState("displayModification"), true);
        dispatch(setState("isModifyClicked", true));
        const date = new Date();

        var startdate = new Date(
            date.getFullYear(),
            date.getMonth(),
            1,
            6,
            30,
            0,
            0
        );
        startdate = startdate.toJSON();
        var lastdate = new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            0,
            6,
            30,
            0,
            0
        );
        lastdate = lastdate.toJSON();
        if (selectedPeriod === "0") {
            startdate = new Date(
                date.getFullYear(),
                date.getMonth() - 1,
                1,
                6,
                30,
                0,
                0
            );
            startdate = startdate.toJSON();
            lastdate = new Date(
                date.getFullYear(),
                date.getMonth(),
                0,
                6,
                30,
                0,
                0
            );
            lastdate = lastdate.toJSON();
        }
        const dateObj = {
            quotaStartDate: startdate,
            quotaEndDate: lastdate,
            depletionPeriodType: rowData.row.depletionPeriodType ?? ""
        }
        dispatch(GetWeekStatus(dateObj));
        //console.log("The row data while clicking the row in datagrid",rowData.row)
        const obj = {
            scenarioId: rowData.id,
            quotaId: rowData.row.quotaID
        }
        dispatch(setState("selectedScenario", rowData.row.scenarioName));
        dispatch(setState("selectedScenarioID", rowData.row.scenarioID));
        dispatch(setState("selectedQuotaID", rowData.row.quotaID));
        dispatch(GetQuotaDetailsForScenario(obj));
        //setIsCollapseOpened(true);
        setIsModificationOpened(true);
    }

    const handleClose = () => setOpen(false);

    const getRowClassName = (params) => {
        return params.row.isModified ? 'modified-row' : '';
    };

    return (
        <div>
            <CollapseSection title="Review Order & Quota: List of scenarios for running period">
                <Box m={2}>
                    <Box>
                        <Backdrop
                            sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.drawer + 1,
                            }}
                            open={isLoading}
                        >
                            <CircularProgress />
                        </Backdrop>
                    </Box>
                    <Box>
                        <MessageForReview />
                    </Box>

                    <Typography variant="subtitle1" my={2}>
                        Search for Scenario
                    </Typography>
                    <Grid container columns={12} justifyContent="flex-start" alignItems="center" spacing={1.5} pb={1}>
                        <Grid item xs={12} sm={6} md={2} lg={2}>
                            <TextField
                                variant="outlined"
                                label="Country"
                                select={countries.length > 0 ? true : false}
                                //select={true}
                                value={countries.length > 0 ? selectedCountry : ""}
                                //value={""}
                                onChange={handleCountryChange}
                                fullWidth
                                size="small"
                            >

                                <MenuItem value={"All"}>{"All"}</MenuItem>
                                {countries.length > 0 ? (
                                    countries.map((country, index) => {
                                        return (
                                            <MenuItem key={country.countryID} value={country.countryName}>
                                                {country.countryName}
                                            </MenuItem>
                                        )
                                    })) : null
                                }

                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={2} lg={2}>
                            <TextField
                                variant="outlined"
                                label="Period"
                                select={true}
                                value={selectedPeriod ? selectedPeriod : ""}
                                onChange={handlePeriodChange}
                                size="small"
                                fullWidth
                            >
                                <MenuItem value="1">Current</MenuItem>
                                <MenuItem value="0">Previous</MenuItem>
                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={6} md={3} lg={3}>
                            <TextField
                                variant="outlined"
                                label="Search"
                                value={searchText}
                                onChange={handleSearchText}
                                fullWidth
                                size="small"
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={1.5} lg={1.5}>
                            <Box justifyContent="flex-end" display="flex">
                                <Button
                                    startIcon={<SearchIcon />}
                                    variant="contained"
                                    onClick={handleRetrive}
                                    size="large"
                                    sx={{
                                        bgcolor: "darkred.light",
                                        color: "white.main",
                                        fontWeight: "700",
                                        textTransform: "none",
                                        "&:hover": {
                                           bgcolor: "darkred.main",
                                        },
                                       
                                    }}
                                >
                                    Search
                                </Button>
                            </Box>
                        </Grid> */}
                        <Grid item xs={12} sm={6} md={4.5} lg={4.5}>
                            <Box display="flex" alignItems="center">
                                <TextField
                                    variant="outlined"
                                    label="Search"
                                    value={searchText}
                                    onChange={handleSearchText}
                                    fullWidth
                                    size="small"
                                />
                                <Button
                                    startIcon={<SearchIcon />}
                                    variant="contained"
                                    onClick={handleRetrive}
                                    size="large"
                                    sx={{
                                        ml: 2, 
                                        bgcolor: "darkred.light",
                                        color: "white.main",
                                        fontWeight: "700",
                                        textTransform: "none",
                                        "&:hover": {
                                            bgcolor: "darkred.main",
                                        },
                                    }}
                                >
                                    Search
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {getScenarios.length > 0 &&
                    <Box sx={{ mt: 3 }}>
                        <DataGrid style={{ maxHeight: 'calc(100vh - 130px)' }}
                            rows={getScenarios}
                            columns={columns}
                            getRowId={(row) => row?.scenarioID}
                            sx={{
                                "& .MuiDataGrid-columnHeaderTitleContainer": {
                                    fontWeight: "bold !important",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat, Sans-serif"
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    whiteSpace: "normal",
                                    lineHeight: "normal",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat, Sans-serif"
                                },
                                "& .MuiDataGrid-columnHeader": {
                                    // Forced to use !important since overriding inline styles
                                    height: "unset !important",
                                    //backgroundColor: "#EEF2F4"
                                },
                                "& .MuiDataGrid-columnHeaders": {
                                    // Forced to use !important since overriding inline styles
                                    maxHeight: "250px !important",
                                },
                            }}
                            onRowClick={handleRowClick}
                            getRowClassName={getRowClassName}
                            disableColumnMenu
                            headerHeight={40}
                            rowHeight = {43}
                            hideFooterSelectedRowCount
                        />
                    </Box>
                }
            </CollapseSection>
            {/*Not required for UCB*/}
            {/* <CollapseSection title="Quota and Consumption" opened={isCollapseOpened} setIsCollapseOpened={setIsCollapseOpened}>
                {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 &&
                    <Box sx={{ mt: 3 }}>
                        <QuotaandConsumption handleRowClick={handleRowClick} setIsModificationOpened={setIsModificationOpened} />
                    </Box>
                }
            </CollapseSection> */}

            <CollapseSection title="Modification" opened={isModificationOpened} setIsCollapseOpened={setIsModificationOpened}>
                {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 &&
                    <Box sx={{ mt: 3 }}>
                        <Modification />
                    </Box>
                }
            </CollapseSection>

        </div>
    )
}

export default ReviewOrdersandQuota